<template>
  <div>
    <wep-loading :is-loading="isLoading"/>
    <iframe
      id="panoptoIframe"
      style="width:0px; height:0px; border:0px; border:none; visibility:hidden; display:none" />
  </div>
</template>

<script>
import WepLoading from '~pages/contents/loading/WepLoading.vue'

export default {
  name: 'PanoptoPlayer',
  metaInfo () {
  },
  components: {
    'wep-loading': WepLoading
  },
  data () {
    return {
      isLoading: false,
      wepSets: this.getStore('mmpAuth').state.wepSets
    }
  },
  computed: {
  },
  watch: {
  },
  beforeUpdate () {
  },
  updated () {
  },
  async created () {
    this.fnPanoptoSso()
  },
  methods: {
    async wepApcActHit () {
      let params = {
        wepApcId: this.getStore('mmpAuth').state.session.userId,
        actHstrScCd: '07',
        videoTrnsTyp: this.wepSets.videoTrnsTyp
      }
      await this.$http.mmp.wepApcActHit(this, params)
    },
    async fnPanoptoSso () {
      this.isLoading = true

      let params = {
        wepApcId: this.getStore('mmpAuth').state.session.userId,
        langId: localStorage.getItem('language')
      }

      this.$http.mmp.panoptoSso(this, params).then( (resultInfo) => {
        if (resultInfo.data.status !== 'OK') {
          this.isLoading = false
          this.commAlert(this.$t('WEP00027'))
        } else {
          this.wepApcActHit()
          if (this.wepSets.videoTrnsTyp === '03' ) {
            this.isLoading = false
            location.href = resultInfo.data.data.videoTrnsUrl
          } else {
            document.getElementById('panoptoIframe').src = resultInfo.data.data.panoptoSsoUrl

            let _this = this
            setTimeout(function () {
              _this.isLoading = false
              location.href = resultInfo.data.data.videoTrnsUrl
            }, 3000)
          }
        }
      }).catch((e) => {
        this.isLoading = false
        this.commAlert(this.$t('WEP00027'))
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/PanoptoPlayer.vue